// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero__2_7BD","link":"link__1niCi","section":"section__2oTnd","content":"content__32K65","buttons":"buttons__1XmRH","divider":"divider__lqFYO"};